<template>

  <div class="card-base card-shadow--medium widget small-widget queue-widget">
    <div class="widget-value ph-10">
      <div class="flex mb-10 mt-10 align-center">
        <span class="mr-5 flex justify-center align-center">
          <v-svg width="18" height="18" class="voxo-blue" sprite="user"/>
        </span>
        <el-input
          class="widget-name-input ml-10"
          v-model="widgetName"
        />
        <el-button
          @click="removeWidget"
          class="table-action-button ml-10"
        >
          <i class="el-icon-delete voxo-dark-red" />
        </el-button>
      </div>
    </div>

    <div class="ph-10 flex align-center">
      <el-input
        class="widget-search-input"
        v-model="searchText"
        placeholder="Search agent"
        clearable
        style="margin-right: 0;"
      >
        <template slot="prefix">
          Agent
        </template>
      </el-input>
      <div>
        <el-popover trigger="click" placement="right-start" popper-class="column-filter-popper">
          <template slot="reference">
            <el-button
              style="height: 50px; border-bottom-left-radius: 0; border-top-left-radius: 0;"
            >
              <i class="mdi mdi-filter voxo-blue" />
            </el-button>
          </template>
          <el-checkbox-group v-model="activeTableFields">
            <el-checkbox
              v-for="(column, index) in tableColumns.filter(item => !['pauseControl', 'loggedIn'].includes(item.field))"
              :key="index"
              :label="column.field"
            >
              {{ column.title }}
            </el-checkbox>
          </el-checkbox-group>
        </el-popover>
      </div>
      <el-select
        v-model="loggedInFilter"
        style="margin-left: auto; margin-right: 0;"
      >
        <el-option value="all" label="All" />
        <el-option value="in" label="Logged in" />
        <el-option value="out" label="Logged out" />
        <template slot="prefix">
          Agent filter
        </template>
      </el-select>
      <el-tooltip placement="top" content="Export">
        <el-button
          @click="doExport"
          style="height: 50px; border-bottom-left-radius: 0; border-top-left-radius: 0;"
        >
          <i class="mdi mdi-file-download voxo-blue" />
        </el-button>
      </el-tooltip>
    </div>

    <div class="table-widget-table ph-10">
      <vxe-grid
        round
        height="100%"
        border="inner"
        ref="xGrid"
        class="user-stats-table"
        empty-text="No Data"
        auto-resize
        :show-overflow="true"
        :scroll-y="{enabled: true, gt: 15, oSize: 0}"
        :sort-config="{defaultSort: {field: 'name', order: 'asc'}}"
        :data="tableData"
        :columns="activeTableColumns"
      />
    </div>

  </div>

</template>

<script>

import {mapGetters} from "vuex";
import {debounce} from 'lodash';
import pauseIcons from "../../../../ref/pause-icons";
import {ExportToCsv} from "export-to-csv";
import moment from 'moment-timezone';
import feathersClient from "../../../../feathers/feathers-client";

export default {
  name: 'AgentsTableQueue',
  props: {
    widgetIndex: {required: true},
    title: {required: true},
    queueNameKey: {required: true},
    columnFields: {required: true},
  },
  data() {
    return {
      widgetName: this.title,
      searchText: '',
      filter: '',
      viewStyle: 'default',
      loggedInFilter: 'in',
      pauseMenuReason: '',
      tableColumns: [
        {
          field: 'loggedIn',
          title: 'Login Controls',
          showHeader: false,
          width: 60,
          slots: {
            default: ({ row }) => {
              return [
                <el-switch
                  value={row.loggedIn === 1}
                  onChange={( value ) => this.toggleLoggedIn(value, row)}
                />
              ]
            },
            header: () => {
              return [
                <span></span>
              ]
            }
          }
        },
        {
          field: 'pauseControl',
          title: 'Pause Controls',
          showHeader: false,
          width: 50,
          slots: {
            default: ({ row }) => {
              return [
                <div v-show={row.loggedIn}>
                  {
                    !!row.paused &&
                    <el-button class="queue-dash-action-button" onClick={() => this.unpause(row)}>
                      <v-svg sprite="play-2"></v-svg>
                    </el-button>
                  }
                  {
                    !row.paused &&
                    <el-dropdown placement="bottom-start" trigger="click">
                      <el-button class="queue-dash-action-button" style="width: 18px; height: 18px;">
                        <v-svg sprite="pause-2"></v-svg>
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                          <el-radio-group v-model={this.pauseMenuReason} onChange={(value) => this.pause(value, row)}>
                            <el-radio
                              class="black-text mt-10"
                              label="Account Review"
                              style="display: block; margin-left: 0;"
                            />
                            <el-radio
                              class="black-text mt-10"
                              label="Break"
                              style="display: block; margin-left: 0;"
                            />
                            <el-radio
                              class="black-text mt-10"
                              label="Lunch"
                              style="display: block; margin-left: 0;"
                            />
                            <el-radio
                              class="black-text mt-10"
                              label="Meeting"
                              style="display: block; margin-left: 0;"
                            />
                            <el-radio
                              class="black-text mt-10"
                              label="Personal"
                              style="display: block; margin-left: 0;"
                            />
                            <el-radio
                              class="black-text mt-10"
                              label="Other"
                              style="display: block; margin-left: 0;"
                            />
                          </el-radio-group>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>

                  }
                </div>
              ]
            },
            header: () => {
              return [
                <span></span>
              ]
            }
          }
        },
        {
          field: 'name',
          title: 'Name',
          minWidth: 175,
          sortable: true,
          formatter: this.nameFormatter
        },
        {
          field: 'queuesCount',
          title: 'Queues',
          minWidth: 75,
          sortable: true,
        },
        {
          field: 'paused',
          title: 'Paused',
          showHeader: false,
          width: 30,
          slots: {
            default: ({ row }) => {
              return [
                <div v-show={row.paused} class="flex align-center justify-center">
                  <el-tooltip placement="top" content={row.lastPauseReason ? row.lastPauseReason : ''}>
                    <v-svg
                      class="voxo-orange pause-icon"
                      width="15"
                      height="15"
                      sprite={this.getPauseIcon(row.lastPauseReason)}
                    />
                  </el-tooltip>
                </div>
              ]
            },
            header: () => {
              return [
                <span></span>
              ]
            }
          }
        },
        {
          field: 'longestCurrentPauseTime',
          title: 'Pause Dur',
          width: 150,
          sortable: true,
          sortType: 'number',
          slots: {
            default: ({row}) => {
              return [
                <span>{row.paused ? this.formatTime(row.longestCurrentPauseTime) : 0}</span>
              ]
            }
          }
        },
        {
          field: 'longestCurrentTalkTime',
          title: 'Talk Dur',
          width: 150,
          sortable: true,
          sortType: 'number',
          slots: {
            default: ({row}) => {
              return [
                <span>{this.formatTime(row.longestCurrentTalkTime)}</span>
              ]
            }
          }
        },
        {
          field: 'extension',
          title: 'Ext',
          minWidth: 175,
          showOverflow: true,
          sortable: true,
        },
        {
          field: 'inboundComplete',
          title: 'Inbound Complete',
          minWidth: 175,
          sortable: true,
        },
        {
          field: 'blindTransfers',
          title: 'Blind Transfers',
          minWidth: 175,
          sortable: true
        },
        {
          field: 'attendedTransfers',
          title: 'Attended Transfers',
          minWidth: 175,
          sortable: true
        },
        {
          field: 'totalTransfers',
          title: 'Total Transfers',
          minWidth: 175,
          sortable: true
        },
        {
          field: 'inboundTalkTime',
          title: 'Queue Talk Time',
          minWidth: 175,
          sortable: true,
          slots: {
            default: ({row}) => {
              return [
                <span>{this.formatTime(row.inboundTalkTime)}</span>
              ]
            }
          }
        },
        {
          field: 'inboundDirect',
          title: 'Inbound Direct (Ans)',
          minWidth: 175,
          sortable: true
        },
        {
          field: 'outboundAnswered',
          title: 'Outbound Answered',
          minWidth: 175,
          sortable: true
        },
        {
          field: 'outboundTalkTime',
          title: 'Outbound Talk Time',
          minWidth: 175,
          sortable: true,
          slots: {
            default: ({row}) => {
              return [
                <span>{this.formatTime(row.outboundTalkTime)}</span>
              ]
            }
          }
        },
        {
          field: 'totalOutbound',
          title: 'Total Outbound',
          minWidth: 175,
          sortable: true
        },
        {
          field: 'refused',
          title: 'Refuse Events',
          minWidth: 175,
          sortable: true
        }
      ]
    }
  },
  computed: {

    ...mapGetters('queueDashAgentAggregates', {agentStoreData: 'list', agentStoreItem: 'get'}),

    tableData() {

      let data = this.agentStoreData;

      if(this.filter){
        data = data.filter(item => item.name.toLowerCase().includes(this.filter.toLowerCase()))
      }

      if(this.loggedInFilter !== 'all'){
        const filter = this.loggedInFilter === 'in' ? 1 : 0;
        data = data.filter(item => item.loggedIn === filter)
      }

      return data;
    },

    activeTableColumns() {
      const defaults = ['pauseControl', 'loggedIn'];
      return this.tableColumns.filter(column => this.columnFields.includes(column.field) || defaults.includes(column.field));
    },

    activeTableFields: {
      get: function () {
        const defaults = ['pauseControl', 'loggedIn'];
        return this.tableColumns.map(column => column.field).filter(field => this.columnFields.includes(field) && !defaults.includes(field));
      },
      set: debounce(function (newValue) {
        //emit an event to change the column fields for the layout index
        this.$emit('updateActiveColumns', {columns: newValue, index: this.widgetIndex});
      }, 150)
    }



  },
  watch: {
    searchText: debounce(function () {
      this.filter = this.searchText;
    }, 250),
    widgetName: debounce(function() {
      if(this.widgetName === this.title) return;
      this.$emit('nameUpdate', {name: this.widgetName, index: this.widgetIndex});
    }, 750)
  },
  methods: {

    getQueueName(data) {
      const { cellValue } = data;
      return this.queueNameKey[cellValue] ? this.queueNameKey[cellValue] : 'Unknown';
    },

    removeWidget(){
      this.$emit('removeWidget', this.widgetIndex);
    },

    nameFormatter(data) {
      const { cellValue } = data;
      return cellValue ? cellValue.replace(/_/g, ' ') : 'Unknown';
    },

    //input is time in seconds. output is pretty time.
    formatTime(time) {
      const hours = Math.floor(time / 3600);
      const remainderSeconds = time % 3600;
      const minutes = Math.floor(remainderSeconds / 60);
      const seconds = Math.round(remainderSeconds % 60);

      if (hours > 0) {return hours + 'hr ' + minutes + 'm';}
      if (minutes > 0) {return minutes + 'm ' + seconds + 's';}
      if (seconds > 0) {return seconds + 's';}
      return '0';
    },

    //pause icons
    getPauseIcon(reason) {
      return pauseIcons(reason);
    },

    //toggle logged in status
    toggleLoggedIn(val, agent){
      console.log("Toggling log to", val);

      const { peerName, paused } = agent;

      //unpause the member first if they are on pause
      if(+paused){
        this.unpause(agent);
      }

      const member = this.agentStoreItem(peerName);

      console.log(agent);
      console.log(member);

      if(member){

        const memberName = member.name;

        //send the global request
        feathersClient.service('nats-actions-handler').create({
          reqType: val ? 'globalQueueLogin' : 'globalQueueLogout',
          peerName,
          memberName,
        });

      }

    },

    pause(reason, agent) {
      const { peerName, name, memberInterface} = agent;

      console.log('toggle pause on', peerName);
      console.log(reason);


      this.pauseMenuReason = '';

      //send the request
      const reqBody = {
        peerName,
        memberName: name,
        interface: memberInterface
      };

      feathersClient.service('nats-actions-handler').create({
        reqType: 'globalQueuePause',
        paused: 1,
        pauseReason: reason,
        ...reqBody
      });

      const agentData = {...agent};

      agentData.paused = 1;
      agentData.lastPauseReason = reason;
      this.$store.commit('queueDashAgentAggregates/updateItem', agentData);


    },

    unpause(agent) {


      const { peerName, name, memberInterface } = agent;

      //send the request
      const reqBody = {
        peerName,
        memberName: name,
        interface: memberInterface
      };

      feathersClient.service('nats-actions-handler').create({
        reqType: 'globalQueueUnpause',
        paused: 0,
        pauseReason: null,
        ...reqBody
      });

      const agentData = {...agent};
      agentData.paused = 0;
      this.$store.commit('queueDashAgentAggregates/updateItem', agentData);
    },

    async doExport() {

      try {
        await this.$confirm('Export agent data?', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        });
      } catch (e) {
        return;
      }

      const data = [...this.agentStoreData];
      if (data.length) {

        const writeData = this.agentStoreData.map(agent => ({
          queue: this.getQueueName(({cellValue: agent.queueId})),
          name: agent.name,
          extension: agent.extension,
          loggedIn: agent.loggedIn,
          paused: agent.paused,
          inboundComplete: agent.inboundComplete,
          blindTransfer: agent.blindTransfers,
          attendedTransfers: agent.attendedTransfers,
          totalTransfers: agent.totalTransfers,
          inboundTalkTime: agent.inboundTalkTime,
          inboundDirect: agent.inboundDirect,
          outboundAnswered: agent.outboundAnswered,
          outboundTalkTime: agent.outboundTalkTime,
          totalOutbound: agent.totalOutbound,
          refused: agent.refused
        }));

        const options = {
          filename: `agent_data_${moment().format('YYYY_MM_DD_HH_mm_ss')}`,
          showLabels: true,
          headers: ['Queue', 'Name', 'Extension', 'Logged In', 'Paused', 'Inbound Completed', 'Blind Transfers', 'Attended Transfers',
          'Total Transfers', 'Queue Talk Time', 'Inbound Direct (Ans)', 'Outbound Answered', 'Outbound Talk Time', 'Total Outbound', 'Refused Events']
        };

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(writeData);
      }
    }

  }
}

</script>
